import React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
import { useTranslation } from 'react-i18next';
import FormControlLabel from '@mui/material/FormControlLabel';
import { filterIcons } from '../icons';
import { Checkbox } from '../../../../../BaseComponents';
const FilterItem = ({ className, onChange, title, checked }) => {
    const { FilterItem: css } = useTheme('Entities').SeatMap;
    const { t } = useTranslation('SeatMap');
    const filterIcon = React.useMemo(() => {
        var _a;
        return (_a = filterIcons[title]) !== null && _a !== void 0 ? _a : null;
    }, [title]);
    return (React.createElement(FormControlLabel, { labelPlacement: "start", classes: { root: cn(css.filter__label, { [css.filter_checked]: checked }, className) }, control: React.createElement(Checkbox, { classes: {
                root: css.checkbox,
                checked: css.checkbox_checked
            }, value: title, checked: checked, onChange: (_, checked) => onChange(title, checked) }), label: React.createElement("div", { className: css.filter__title },
            filterIcon && React.createElement("span", { className: css.filter__icon }, filterIcon),
            t(`Restriction_${title}`)) }));
};
export default FilterItem;
